import { Editor as TinyMceEditor } from "@tinymce/tinymce-react";
import { CONFIG } from "../../config/configs";

const Editor = ({ description, setDescription, variables }) => {
	const handleVariables = (event) => {
		if (event.target.value === "") {
			return;
		}
		window.tinymce.activeEditor.execCommand(
			"mceInsertContent",
			false,
			`${event.target.value}`
		);
	};

	const filepicker = (cb) => {
		var input = document.createElement("input");
		input.setAttribute("type", "file");
		input.setAttribute("accept", "image/*");

		input.onchange = function () {
			var file = this.files[0];

			var reader = new FileReader();
			reader.onload = function () {
				/*
		  Note: Now we need to register the blob in TinyMCEs image blob
		  registry. In the next release this part hopefully won't be
		  necessary, as we are looking to handle it internally.
		*/
				var id = "blobid" + new Date().getTime();
				var blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
				var base64 = reader.result.split(",")[1];
				var blobInfo = blobCache.create(id, file, base64);
				blobCache.add(blobInfo);

				/* call the callback and populate the Title field with the file name */

				// cb(blobInfo.blobUri(), { title: file.name })
				cb(reader.result, { title: file.name });
			};
			reader.readAsDataURL(file);
		};

		input.click();
	};

	return (
		<>
			<div className="text-right">
				<label>Variables: </label>
				<select
					className="template-variable-dropdown"
					onChange={handleVariables}
					value=""
				>
					<option value="">Select</option>
					{variables?.map((item) => {
						return (
							<option key={item?.id} value={item?.value}>
								{item?.label}
							</option>
						);
					})}
				</select>
			</div>
			<TinyMceEditor
				apiKey={CONFIG.TINY_MCE_API_KEY}
				value={description}
				init={{
					height: 500,
					max_height: 700,
					menubar: true,
					plugins: [
						"advlist autolink lists",
						"charmap print preview anchor help",
						"searchreplace visualblocks code",
						"insertdatetime media table paste",
						"textcolor colorpicker",
						"code",
						"image",
						"link",
						"preview",
						"searchreplace",
						"table",
						"wordcount",
					],
					toolbar: [
						"bold italic underline superscript subscript| fontsize | blocks | fontfamily | forecolor backcolor  | \
					alignleft aligncenter alignright |  \
					bullist numlist outdent indent| image link | \
					searchreplace code preview wordcount",
					],
					image_title: true,
					automatic_uploads: true,
					paste_data_images: true,
					file_picker_types: "image",
					file_picker_callback: filepicker,
				}}
				onEditorChange={(e) => {
					setDescription({ target: { name: "email_body", value: e } });
				}}
			/>
		</>
	);
};

export default Editor;
